import * as React from 'react';
import { useEffect } from 'react';
import { Box } from '@apia/theme';
import { useMount } from 'ahooks';
import { useAppDispatch, useAppSelector } from '../../../hooks/hooks';
import ApiaPage from './page/ApiaPage';
import Render from '../../common/tabs/Render';
import ServerSubmitForm from './page/ServerSubmitForm';
import ValidationContextProvider from '../../common/previousValidation/ValidationContext';
import { buttonsActions } from '../../../store/buttonsSlice';
import ApiaEditGridPage from './page/ApiaEditGridPage';
import { getJSObjfromXML, unescapeMarkup } from '../../../utils/util';
import { ApiaUtil } from '@apia/components';
import FormsAssistant from '../ai/execution/FormsAssistant';

export const EXECUTION_FORM = 'executionData';

/**
 * Searchs for errors in the HTML document and if there is some,
 * dispatches it to the notifications system.
 * */
const notifyExecutionErrors = () => {
  const errXML = unescapeMarkup(window.EXEC_ERRORS);
  if (errXML) {
    getJSObjfromXML(errXML);
  }
};

const FormsController = ({
  children,
  isgrid,
  ...props
}: {
  children?: React.ReactNode;
  [key: string]: unknown;
}): JSX.Element => {
  const dispatch = useAppDispatch();
  const { confirmSubmitSucessMsg, autoCloseTab: shouldAutoCloseTab } =
    useAppSelector((state) => state.confirmFormSlice);

  useMount(() => {
    notifyExecutionErrors();

    dispatch(
      buttonsActions.updateAction([
        {
          action: 'next',
          suggested: true,
        },
        {
          action: 'confirm',
          suggested: true,
        },
      ]),
    );
  });

  useEffect(() => {
    if (shouldAutoCloseTab) {
      ApiaUtil.instance.tabs.currentTab.close(true);
    }
  }, [shouldAutoCloseTab]);

  const Page = isgrid ? ApiaEditGridPage : ApiaPage;

  return (
    <Box {...props}>
      <FormsAssistant />
      {confirmSubmitSucessMsg === null && (
        <ValidationContextProvider form={EXECUTION_FORM}>
          <Page>
            <Render>{children}</Render>
          </Page>
        </ValidationContextProvider>
      )}
      <ServerSubmitForm />
    </Box>
  );
};

export default FormsController;
